import { render, staticRenderFns } from "./MemberMarketingPrivacy.vue?vue&type=template&id=063f33b3&scoped=true&"
import script from "./MemberMarketingPrivacy.vue?vue&type=script&lang=js&"
export * from "./MemberMarketingPrivacy.vue?vue&type=script&lang=js&"
import style0 from "./MemberMarketingPrivacy.vue?vue&type=style&index=0&id=063f33b3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f33b3",
  null
  
)

export default component.exports